import { errorToast } from "@/v2-ui/toast"
import {
  type ConfirmButtonProps,
  ConfirmButton,
} from "@/v2-backoffice-client/components/button"
import { useTenantRemoveMutation } from "@/v2-backoffice-client/tenant/remove/tenant.remove.mutation"

export type TenantRemoveButtonProps = Omit<ConfirmButtonProps, "onConfirm"> & {
  tenantId: number | null | undefined
  confirmDescription?: string
  onCompleted?(): void
}

function TenantRemoveButton(props: TenantRemoveButtonProps) {
  const { tenantId, confirmDescription, onCompleted, ...rest } = props

  const [removeTenant, { loading, error }] = useTenantRemoveMutation({
    onCompleted,
  })

  errorToast(error, {
    title: "Failed to remove team",
  })

  return (
    <ConfirmButton
      id="tenant-remove-button"
      variant="destructive"
      size="tiny"
      iconSrc="trash"
      content="Remove team"
      confirmContent={
        confirmDescription ?? "Are you sure you want to remove this team?"
      }
      isLoading={loading}
      disabled={!tenantId}
      onConfirm={() => {
        if (!tenantId) return
        removeTenant({ variables: { id: tenantId } })
      }}
      {...rest}
    />
  )
}

export default TenantRemoveButton
